const TYPE = `[APPS]`;

const TYPES = {
    FETCH_START: `${TYPE} FETCH START`,
    FETCH_SUCCESS: `${TYPE} FETCH SUCCESS`,
    FETCH_ERROR: `${TYPE} FETCH ERROR`,

    FETCH_AVAILABLE_START: `${TYPE} FETCH AVAILABLE START`,
    FETCH_AVAILABLE_SUCCESS: `${TYPE} FETCH AVAILABLE SUCCESS`,
    FETCH_AVAILABLE_ERROR: `${TYPE} FETCH AVAILABLE ERROR`,

    RESET_ERROR: `${TYPE} RESET ERROR`,
}

export default TYPES;